import { Calculation, PaymentFrequency } from '@servicetitan/financing-api-client';
import { Divider, Flex } from '@servicetitan/anvil2';
import { Payment } from './Payment';

interface PromotionalProps {
    plan: Calculation;
    currentFrequency?: PaymentFrequency;
    placeholder?: boolean;
}
export const Promotional = ({ plan, currentFrequency, placeholder }: PromotionalProps) => {
    return (
        <Flex style={{ width: '85%' }}>
            <Payment
                plan={plan}
                isPromoStart
                eyebrowText="Min. Payment"
                currentFrequency={currentFrequency}
                placeholder={placeholder}
            />
            <Divider vertical spacing="1" style={{ marginLeft: 'auto', marginRight: '1rem' }} />
            <Payment plan={plan} currentFrequency={currentFrequency} placeholder={placeholder} />
        </Flex>
    );
};
